import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_paper_stationery: FaireCategoryEntity = {
  token: "cat_paper-stationery",
  type: "category",
  name: "Stationery",
  level: 2,
  parentToken: "cat_paper-novelty",
  href: "/category/stationery",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
